import subcategoryProductsSymbols from "../symbols/subcategoryProducts";

const initialState = {
  data: {
    Variants: [],
    Total: 0
  },
  page: 1,
  loading: false,
  error: false,
};

export default function SubcategoryProductsSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case subcategoryProductsSymbols.GET_SUBCATEGORY_PRODUCTS:
      return { ...state, loading: true, error: false };
    case subcategoryProductsSymbols.SET_SUBCATEGORY_PAGE:
      return { ...state, page: action.payload };
    case subcategoryProductsSymbols.GET_SUBCATEGORY_PRODUCTS_SUCCESS:
      return {
        ...state,
        data: {
          Variants: state.page === 1
            ? action.payload.Result.Variants 
            : [...state.data.Variants, ...action.payload.Result.Variants],
          Total: action.payload.Result.Total
        },
        loading: false,
        error: false,
      };
    case subcategoryProductsSymbols.GET_SUBCATEGORY_PRODUCTS_FAILURE:
      return {
        ...state,
        data: initialState.data,
        page: 1,
        loading: false,
        error: true,
      };
    case subcategoryProductsSymbols.CLEAR_GET_SUBCATEGORY_PRODUCTS:
      return {
        ...state,
        data: initialState.data,
        page: 1,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
